module.exports = __webpack_public_path__ + "static/media/mtnmoney.dd7c7ba7.png";